import { render, staticRenderFns } from "./ComprometimentoPesquisa.vue?vue&type=template&id=6383975d"
import script from "./ComprometimentoPesquisa.vue?vue&type=script&lang=js"
export * from "./ComprometimentoPesquisa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports